<script setup lang="ts">
import { NO_OP } from "vue-composable";
import MAppointmentDiary from "./MAppointmentDiary.vue";
import { AppointmentDiary } from "./types";
import { NOOP } from "@vue/shared";

const diary: AppointmentDiary = {
  scheduleType: "diary",
  id: "01964407-773c-73da-b253-9ff0f4c51c30",
  startDateTime: "2025-04-23 12:00:00",
  endDateTime: "2025-04-23 14:00:00",
  summary: {
    site: {
      id: "01964407-76b2-736e-909a-348485077683",
      name: "Andover Site",
    },
    room: null,
    service: {
      id: "01964407-76b5-70c6-accc-db13189dc98b",
      name: "GP Home Visits",
    },
    status: {
      value: "active",
      label: "Active",
      isActive: true,
      isCancelled: false,
    },
    startDateTime: "2025-04-23 12:00:00",
    endDateTime: "2025-04-23 14:00:00",
    defaultDeliveryMode: {
      value: "home-visit",
      label: "Home visit",
      isFaceToFace: false,
      isHomeVisit: true,
      isPhone: false,
      isVideo: false,
    },
    usualAppointmentDuration: 30,
    assignees: [
      {
        id: "01964407-8938-7163-b3e2-b7abdb9b21a1",
        displayName: "Dr Amelia Cook",
      },
    ],
    booked: {
      count: 4,
      duration: "2 hrs 30 mins",
    },
    available: {
      count: 0,
      duration: null,
    },
    additionalInformation: [],
    defaultAppointmentType: {
      id: "01964407-773b-70b0-9475-fa62a8840c2a",
      appointmentService: {
        id: "01964407-76b5-70c6-accc-db13189dc98b",
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Home Visits",
        patientFacingName: null,
        appointmentTypes: [],
      },
      status: {
        value: "active",
        label: "Active",
        isActive: true,
        isArchived: false,
      },
      name: "GP Home Visits PFS",
      patientFacingName: "Appointment",
      patientFacingOrInternalName: "Appointment",
      defaultDeliveryMode: {
        value: "home-visit",
        label: "Home visit",
        isFaceToFace: false,
        isHomeVisit: true,
        isPhone: false,
        isVideo: false,
      },
      defaultUsualAppointmentDuration: 30,
      defaultNHSNationalSlotTypeCategory: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      internalBookingOpensDaysBeforeContainerStartDate: null,
      internalBookingOpensAtTime: null,
      patientFacingServicesAvailability: {
        value: "available",
        label: "Available",
        isAvailable: true,
        isNotAvailable: false,
      },
      patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
      patientFacingServicesBookingOpensAtTime: null,
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      gpConnectBookingOpensDaysBeforeContainerStartDate: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
      availableProcedures: [],
    },
    nhsNationalSlotTypeCategoryDefault: {
      value: "30101",
      label: "General Consultation Acute",
      isActive: true,
      isCareRelatedEncounter: true,
    },
    internalBookingOpensDateTime: null,
    patientFacingServicesAvailability: null,
    patientFacingServicesBookingOpensDateTime: null,
    canBeCancelled: false,
    supportsTimedAppointments: true,
    supportsUntimedAppointments: true,
    canBookUntimedAppointments: true,
    isAtCapacity: true,
    hasHighPriorityUntimedAppointments: false,
    diaryTimeline: [
      {
        appointmentTypeId: "01964407-773b-70b0-9475-fa62a8840c2a",
        name: "GP Home Visits PFS",
        startDateTime: "2025-04-23 12:00:00",
        endDateTime: "2025-04-23 14:00:00",
      },
    ],
  },
  entries: [
    {
      isLocalAppointment: true,
      id: "01964408-1c25-736c-bf74-8d9b40dcbd9d",
      versionId: "9d4202abbf873d3ddd3fb2ff756b2a54",
      overlapsWithOtherAppointments: true,
      patient: {
        id: "01964407-3568-7241-8d25-dad0a85a1f6d",
        name: "Miss Xin Qian Pai",
        firstNames: "Miss Xin Qian",
        familyName: "Pai",
        officialDisplayName: "Miss Xin Qian Pai",
        nameParts: {
          prefix: "Miss",
          givenName: "Xin Qian",
          middleNames: null,
          familyName: "Pai",
          suffix: null,
        },
        preferredName: null,
        nhsNumber: "9730326843",
        dateOfBirth: "1964-04-17",
        homePhoneNumber: null,
        mobilePhoneNumber: null,
        homeAddress: "PENROSE HOUSE, 16 NEWSHOLME DRIVE, LONDON, N21 1TW, GBR",
        emailAddress: null,
        deceased: false,
        risks: [],
      },
      type: {
        value: "timed",
        label: "Timed",
        isTimed: true,
        isUntimed: false,
      },
      diaryEntryType: {
        value: "appointment",
        label: "Appointment",
        isAppointment: true,
        isSlot: false,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      isHighPriority: false,
      isHiddenFromPatientFacingServices: false,
      serviceName: "GP Home Visits",
      intendedOrContainerStartDateTime: "2025-04-23 12:00:00",
      intendedOrContainerEndDateTime: "2025-04-23 12:30:00",
      startDateTime: "2025-04-23 12:00:00",
      endDateTime: "2025-04-23 12:30:00",
      duration: 30,
      queueStartDateTime: null,
      queueEndDateTime: null,
      diaryStartDateTime: "2025-04-23 12:00:00",
      diaryEndDateTime: "2025-04-23 14:00:00",
      assignees: "Dr Amelia Cook",
      location: "Andover Site",
      reasonForAppointment: "Asthma review.",
      additionalInformation: null,
      patientSuppliedInformationForClinician: null,
      compiledReasonForAppointment: "Asthma review.",
      displayStatus: {
        value: "booked",
        label: "Booked",
        isArrived: false,
        isCalledIn: false,
        isBooked: true,
        isDidNotAttend: false,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
      },
      createdDateTime: "2025-04-17 14:55:04",
      deliveryMode: {
        value: "video",
        label: "Video",
        isFaceToFace: false,
        isHomeVisit: false,
        isPhone: false,
        isVideo: true,
      },
      appointmentStatus: {
        value: "pending",
        label: "Pending",
        isPending: true,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
        isDidNotAttend: false,
      },
      arrivalStatus: null,
      arrivedDateTime: null,
      virtualMeetingRoomId: null,
      encounterId: null,
      encounterIsDraft: null,
      isPending: true,
      formattedTimesAndDuration: "12:00 - 12:30 (30 mins)",
      formattedDateTimeRange: "Wed 23 Apr 2025, 12:00 - 12:30",
      cancelledDateTime: null,
      rescheduledDateTime: null,
      cancellationReason: null,
      diaryId: "01964407-773c-73da-b253-9ff0f4c51c30",
      queueId: null,
    },
    {
      isLocalAppointment: true,
      id: "019661cf-1327-703f-893d-c78446278e1b",
      versionId: "9b10e00eefa9a498d83faae552186b14",
      overlapsWithOtherAppointments: true,
      patient: {
        id: "01964407-9504-70d9-973f-0ecd49f92b56",
        name: "Mr Zach Bell",
        firstNames: "Mr Zach",
        familyName: "Bell",
        officialDisplayName: "Mr Zach Bell",
        nameParts: {
          prefix: "Mr",
          givenName: "Zach",
          middleNames: "Christopher",
          familyName: "Bell",
          suffix: "IV",
        },
        preferredName: null,
        nhsNumber: "9449306249",
        dateOfBirth: "1971-06-02",
        homePhoneNumber: null,
        mobilePhoneNumber: "+441273184360",
        homeAddress: "Flat 00j, Port Joseph, Worcestershire, OX11 8JJ, GBR",
        emailAddress: "ben59@hotmail.com",
        deceased: false,
        risks: [],
      },
      type: {
        value: "timed",
        label: "Timed",
        isTimed: true,
        isUntimed: false,
      },
      diaryEntryType: {
        value: "appointment",
        label: "Appointment",
        isAppointment: true,
        isSlot: false,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      isHighPriority: false,
      isHiddenFromPatientFacingServices: false,
      serviceName: "GP Home Visits",
      intendedOrContainerStartDateTime: "2025-04-23 12:00:00",
      intendedOrContainerEndDateTime: "2025-04-23 12:30:00",
      startDateTime: "2025-04-23 12:00:00",
      endDateTime: "2025-04-23 12:30:00",
      duration: 30,
      queueStartDateTime: null,
      queueEndDateTime: null,
      diaryStartDateTime: "2025-04-23 12:00:00",
      diaryEndDateTime: "2025-04-23 14:00:00",
      assignees: "Dr Amelia Cook",
      location: "Andover Site",
      reasonForAppointment: null,
      additionalInformation: null,
      patientSuppliedInformationForClinician: null,
      compiledReasonForAppointment: "No reason given.",
      displayStatus: {
        value: "booked",
        label: "Booked",
        isArrived: false,
        isCalledIn: false,
        isBooked: true,
        isDidNotAttend: false,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
      },
      createdDateTime: "2025-04-23 09:41:23",
      deliveryMode: {
        value: "home-visit",
        label: "Home visit",
        isFaceToFace: false,
        isHomeVisit: true,
        isPhone: false,
        isVideo: false,
      },
      appointmentStatus: {
        value: "pending",
        label: "Pending",
        isPending: true,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
        isDidNotAttend: false,
      },
      arrivalStatus: null,
      arrivedDateTime: null,
      virtualMeetingRoomId: null,
      encounterId: null,
      encounterIsDraft: null,
      isPending: true,
      formattedTimesAndDuration: "12:00 - 12:30 (30 mins)",
      formattedDateTimeRange: "Wed 23 Apr 2025, 12:00 - 12:30",
      cancelledDateTime: null,
      rescheduledDateTime: null,
      cancellationReason: null,
      diaryId: "01964407-773c-73da-b253-9ff0f4c51c30",
      queueId: null,
    },
    {
      isLocalAppointment: true,
      id: "019661dc-93d2-71af-a141-65c686fe2818",
      versionId: "909ea8bd8375737f232cf48eec0b2793",
      overlapsWithOtherAppointments: true,
      patient: {
        id: "01964407-9504-70d9-973f-0ecd49f92b56",
        name: "Mr Zach Bell",
        firstNames: "Mr Zach",
        familyName: "Bell",
        officialDisplayName: "Mr Zach Bell",
        nameParts: {
          prefix: "Mr",
          givenName: "Zach",
          middleNames: "Christopher",
          familyName: "Bell",
          suffix: "IV",
        },
        preferredName: null,
        nhsNumber: "9449306249",
        dateOfBirth: "1971-06-02",
        homePhoneNumber: null,
        mobilePhoneNumber: "+441273184360",
        homeAddress: "Flat 00j, Port Joseph, Worcestershire, OX11 8JJ, GBR",
        emailAddress: "ben59@hotmail.com",
        deceased: false,
        risks: [],
      },
      type: {
        value: "timed",
        label: "Timed",
        isTimed: true,
        isUntimed: false,
      },
      diaryEntryType: {
        value: "appointment",
        label: "Appointment",
        isAppointment: true,
        isSlot: false,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      isHighPriority: false,
      isHiddenFromPatientFacingServices: false,
      serviceName: "GP Home Visits",
      intendedOrContainerStartDateTime: "2025-04-23 12:00:00",
      intendedOrContainerEndDateTime: "2025-04-23 13:00:00",
      startDateTime: "2025-04-23 12:00:00",
      endDateTime: "2025-04-23 13:00:00",
      duration: 60,
      queueStartDateTime: null,
      queueEndDateTime: null,
      diaryStartDateTime: "2025-04-23 12:00:00",
      diaryEndDateTime: "2025-04-23 14:00:00",
      assignees: "Dr Amelia Cook",
      location: "Andover Site",
      reasonForAppointment: null,
      additionalInformation: null,
      patientSuppliedInformationForClinician: null,
      compiledReasonForAppointment: "No reason given.",
      displayStatus: {
        value: "booked",
        label: "Booked",
        isArrived: false,
        isCalledIn: false,
        isBooked: true,
        isDidNotAttend: false,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
      },
      createdDateTime: "2025-04-23 09:56:07",
      deliveryMode: {
        value: "home-visit",
        label: "Home visit",
        isFaceToFace: false,
        isHomeVisit: true,
        isPhone: false,
        isVideo: false,
      },
      appointmentStatus: {
        value: "pending",
        label: "Pending",
        isPending: true,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
        isDidNotAttend: false,
      },
      arrivalStatus: null,
      arrivedDateTime: null,
      virtualMeetingRoomId: null,
      encounterId: null,
      encounterIsDraft: null,
      isPending: true,
      formattedTimesAndDuration: "12:00 - 13:00 (60 mins)",
      formattedDateTimeRange: "Wed 23 Apr 2025, 12:00 - 13:00",
      cancelledDateTime: null,
      rescheduledDateTime: null,
      cancellationReason: null,
      diaryId: "01964407-773c-73da-b253-9ff0f4c51c30",
      queueId: null,
    },
    {
      isLocalAppointment: true,
      id: "019661cc-99f3-72e5-93a2-4e1c56beaf71",
      versionId: "258738d73a9e63fa06ee2ff8d478af85",
      overlapsWithOtherAppointments: true,
      patient: {
        id: "01964407-9504-70d9-973f-0ecd49f92b56",
        name: "Mr Zach Bell",
        firstNames: "Mr Zach",
        familyName: "Bell",
        officialDisplayName: "Mr Zach Bell",
        nameParts: {
          prefix: "Mr",
          givenName: "Zach",
          middleNames: "Christopher",
          familyName: "Bell",
          suffix: "IV",
        },
        preferredName: null,
        nhsNumber: "9449306249",
        dateOfBirth: "1971-06-02",
        homePhoneNumber: null,
        mobilePhoneNumber: "+441273184360",
        homeAddress: "Flat 00j, Port Joseph, Worcestershire, OX11 8JJ, GBR",
        emailAddress: "ben59@hotmail.com",
        deceased: false,
        risks: [],
      },
      type: {
        value: "timed",
        label: "Timed",
        isTimed: true,
        isUntimed: false,
      },
      diaryEntryType: {
        value: "appointment",
        label: "Appointment",
        isAppointment: true,
        isSlot: false,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      isHighPriority: false,
      isHiddenFromPatientFacingServices: false,
      serviceName: "GP Home Visits",
      intendedOrContainerStartDateTime: "2025-04-23 12:30:00",
      intendedOrContainerEndDateTime: "2025-04-23 13:00:00",
      startDateTime: "2025-04-23 12:30:00",
      endDateTime: "2025-04-23 13:00:00",
      duration: 30,
      queueStartDateTime: null,
      queueEndDateTime: null,
      diaryStartDateTime: "2025-04-23 12:00:00",
      diaryEndDateTime: "2025-04-23 14:00:00",
      assignees: "Dr Amelia Cook",
      location: "Andover Site",
      reasonForAppointment: null,
      additionalInformation: null,
      patientSuppliedInformationForClinician: null,
      compiledReasonForAppointment: "No reason given.",
      displayStatus: {
        value: "booked",
        label: "Booked",
        isArrived: false,
        isCalledIn: false,
        isBooked: true,
        isDidNotAttend: false,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
      },
      createdDateTime: "2025-04-23 09:38:40",
      deliveryMode: {
        value: "home-visit",
        label: "Home visit",
        isFaceToFace: false,
        isHomeVisit: true,
        isPhone: false,
        isVideo: false,
      },
      appointmentStatus: {
        value: "pending",
        label: "Pending",
        isPending: true,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
        isDidNotAttend: false,
      },
      arrivalStatus: null,
      arrivedDateTime: null,
      virtualMeetingRoomId: null,
      encounterId: null,
      encounterIsDraft: null,
      isPending: true,
      formattedTimesAndDuration: "12:30 - 13:00 (30 mins)",
      formattedDateTimeRange: "Wed 23 Apr 2025, 12:30 - 13:00",
      cancelledDateTime: null,
      rescheduledDateTime: null,
      cancellationReason: null,
      diaryId: "01964407-773c-73da-b253-9ff0f4c51c30",
      queueId: null,
    },
    {
      id: "019661dc-0cfb-7217-a654-cb95dcbcf472",
      diaryEntryType: {
        value: "staff-break-assignment",
        label: "Staff break",
        isAppointment: false,
        isSlot: false,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: true,
      },
      title: "Break",
      startDateTime: "2025-04-23 13:00:00",
      endDateTime: "2025-04-23 13:30:00",
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-773c-73da-b253-9ff0f4c51c30",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "home-visit",
        label: "Home visit",
        isFaceToFace: false,
        isHomeVisit: true,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "available",
        label: "Available",
        isAvailable: true,
        isNotAvailable: false,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 13:30:00",
      endDateTime: "2025-04-23 14:00:00",
      diaryStartDateTime: "2025-04-23 12:00:00",
      diaryEndDateTime: "2025-04-23 14:00:00",
      duration: 30,
      appointmentType: {
        id: "01964407-773b-70b0-9475-fa62a8840c2a",
        appointmentService: {
          id: "01964407-76b5-70c6-accc-db13189dc98b",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Home Visits",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Home Visits PFS",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "home-visit",
          label: "Home visit",
          isFaceToFace: false,
          isHomeVisit: true,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 30,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "available",
          label: "Available",
          isAvailable: true,
          isNotAvailable: false,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        patientFacingServicesBookingOpensAtTime: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 30,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Home Visits",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
  ],
  untimedAppointments: [],
};
</script>

<template>
  <div style="width: 500px">
    <m-appointment-diary
      :title="diary.summary.service.name"
      :diary="diary"
      :show-diary-controls="true"
      heading="GP Surgery"
      @click="NO_OP"
      @cancel-diary="NOOP"
    />
  </div>
</template>
